import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateAssigmentApprovalUnit } from '@api/assignApprovalUnit';

import { IUpdateApprovalUnitDTO } from '@interfaces/organisation/dto/approvalUnitsDTO';

import { ESnackbarTypes } from '@enums/common';

import {
	ASSIGN_APPROVAL_UNITS,
	FILTER_ASSIGN_APPROVAL_UNITS,
	UPDATE_ASSIGNMENT_APPROVAL_UNIT,
} from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUpdateAssignmentApprovalUnit = (onSettledCallbacks: Array<() => void>) => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate: handleUpdateAssignApprovalUnit,
		isLoading: isLoadingUpdateAssignApprovalUnit,
	} = useMutation<IUpdateApprovalUnitDTO>({
		mutationKey: [UPDATE_ASSIGNMENT_APPROVAL_UNIT],
		mutationFn: updateAssigmentApprovalUnit,
		onSuccess: () => {
			onSettledCallbacks.forEach((callback) => callback());

			dispatch(
				setSnackbar({
					message: responseMessages.updateAssignmentApprovalUnit,
					type: ESnackbarTypes.success,
				}),
			);

			return [
				queryClient.invalidateQueries([ASSIGN_APPROVAL_UNITS]),
				queryClient.invalidateQueries([FILTER_ASSIGN_APPROVAL_UNITS]),
			];
		},
	});

	return {
		isLoadingUpdateAssignApprovalUnit,
		handleUpdateAssignApprovalUnit,
	};
};
